import { Store } from '@betgames/bg-state-manager';
import { IChatStoreModel } from './interfaces';
import { sessionStore } from '../Session';

class ChatStore extends Store<IChatStoreModel> {
    constructor() {
        super({
            key: 'Chat',
            default: {
                isLoggedIn: false,
                isLoading: false,
                isBanned: false,
                nickname: null,
                userId: null,
                channelId: null,
                error: null,
                messages: [],
                userNames: {},
            },
        });
    }

    public get nickname(): string {
        return this.value.nickname;
    }

    public get userId(): string {
        return this.value.userId;
    }

    public get isLoggedIn(): boolean {
        return this.value.isLoggedIn;
    }

    public get isRegistered(): boolean {
        return !!(sessionStore.nickname || this.value.userId);
    }

    public get isBanned(): boolean {
        return this.value.isBanned;
    }

    public get userNamesList(): Record<string, string> {
        return this.value.userNames;
    }

    public get messageList(): IChatStoreModel['messages'] {
        return this.value.messages;
    }

    public get isJoinedChannel(): boolean {
        return !!this.value.channelId;
    }

    public get channelId(): string {
        return this.value.channelId;
    }

    public getUserName(userId: string) {
        return this.value.userNames?.[userId];
    }

    public resetState(): void {
        this.reset();
    }

    public setLoading(loading?: boolean) {
        this.update((draft) => {
            if (loading) {
                draft.error = null;
            }
            draft.isLoading = !!loading;
        });
    }

    public setError(error: string): void {
        this.update((draft) => {
            draft.isLoading = false;
            draft.error = error;
        });
    }

    public resetError(): void {
        this.update((draft) => {
            draft.error = null;
        });
    }

    public setChannelId(channelId?: string): void {
        this.update((draft) => {
            draft.channelId = channelId;
        });
    }

    public setUserAuthData(nickname: string, userId: string): void {
        this.resetError();
        this.update((draft) => {
            draft.nickname = nickname;
            draft.userId = userId;
        });
    }

    public setUserLoggedIn(): void {
        this.update((draft) => {
            draft.isLoggedIn = true;
        });
    }

    public setMessages(messages: IChatStoreModel['messages']) {
        this.update((draft) => {
            draft.messages = messages;
        });
    }

    public addUsername(userId: string, displayName: string) {
        if (!this.value.userNames[userId]) {
            this.update((draft) => {
                draft.userNames[userId] = displayName;
            });
        }
    }

    public resetChannelConnection(): void {
        this.update((draft) => {
            draft.channelId = null;
            draft.messages = [];
        });
    }

    public setIsBanned() {
        this.update((draft) => {
            draft.isBanned = true;
        });
    }
}

export const chatStore = new ChatStore();
